var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.406.585a1.998 1.998 0 0 0-2.825 0l-.54.54a.741.741 0 1 0-1.048 1.048l.175.175-5.826 5.825-2.022 2.023a.91.91 0 0 0-.266.602l-.005.108v.002l-.081 1.829a.302.302 0 0 0 .302.316h.013l.97-.044.592-.026.268-.012c.297-.013.579-.137.79-.347l7.77-7.77.146.144a.74.74 0 0 0 1.048 0c.29-.29.29-.759 0-1.048l.54-.54c.78-.78.78-2.044 0-2.825zM8.795 7.333l-2.73.515 4.452-4.452 1.108 1.107-2.83 2.83zM2.08 13.673c-1.148 0-2.08.295-2.08.66 0 .363.932.658 2.08.658 1.15 0 2.08-.294 2.08-.659 0-.364-.93-.659-2.08-.659z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.7607d1def16eeb68f453f1f11288d220.svg";
export { ForwardRef as ReactComponent };